/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { errorProvisionalDetailConfig } from '../../config/error.config';

export interface IErrorProvisionalDetailContentPluginMethods
  extends IPluginMethodMap {
  getErrorProvisionalDetailContentSync(args?: any): any;
}

export class ErrorProvisionalDetailContentPlugin implements IAgentPlugin {
  readonly methods: IErrorProvisionalDetailContentPluginMethods;

  constructor() {
    this.methods = {
      getErrorProvisionalDetailContentSync:
        this.getErrorProvisionalDetailContentSync.bind(this),
    };
  }

  getErrorProvisionalDetailContentSync(args?: any) {
    return {
      error: errorProvisionalDetailConfig,
    };
  }
}
